// export const BASE_URL = 'https://api.chainalysis.credit/api/'
// export const BASE_URL = 'https://backend.geminiltd.online/api/';
// export const BASE_URL = 'https://backend.thetrademarkets.com/api/';
// export const BASE_URL = 'https://backend.Veltra Coin500.com/api/';
// export const BASE_URL = 'https://backend.veltracoin.com/api/';
// export const BASE_URL = 'https://wallet-api.developer-bd3.xyz/api/';
// export const BASE_URL = 'https://backendcrypto.developer-ma.com/api/';
// export const BASE_URL = 'https://staggingbackend.thetrademarkets.com/api/';
// export const BASE_URL = 'https://backend.wenexus500.com/api/';
export const BASE_URL = 'https://backend.elementuslabs.io/api/';
